<h1 style="display: none">{{ environment.title }}</h1>
<a
  class="collectif-link"
  href="{{ environment.collectifUrl }}"
  alt="Podcasts, actus, évènements par les membres du collectif Technomad."
  title="Podcasts, actus, évènements par les membres du collectif Technomad."
>
  <div class="enseigne-block">
    <div class="enseigne">
      <!--<picture alt="Logo Collectif Technomad">
        <source srcset="/assets/imgs/logo_collectif_small.webp" type="image/webp"/>
        <source srcset="/assets/imgs/logo_collectif_small.png" type="image/png"/>
        <img src="/assets/imgs/logo_collectif_small.png" alt="Logo Collectif Technomad">
      </picture>-->
      <div class="h1">
        <div class="collectif">Collectif</div>
        <div class="technomad">Technomad</div>
      </div>
    </div>
  </div>
</a>
<a
  class="audio-link"
  href="{{ environment.audioUrl }}"
  alt="Matériel évènementiel (sonorisation, éclairage, électricité, structure) proposé en location par Technomad Audio."
  title="Matériel évènementiel (sonorisation, éclairage, électricité, structure) proposé en location par Technomad Audio."
>
  <div class="enseigne-block">
    <div class="enseigne">
      <div class="h1">
        <div class="technomad">Technomad</div>
        <div class="audio">Audio</div>
      </div>
      <!--<picture alt="Logo Technomad Audio">
          <source srcset="/assets/imgs/logo_audio_small.webp" type="image/webp"/>
          <source srcset="/assets/imgs/logo_audio_small.png" type="image/png"/>
          <img src="/assets/imgs/logo_audio_small.png" alt="Logo Technomad Audio">
        </picture>-->
    </div>
  </div>
</a>
